import { render, staticRenderFns } from "./ShippoAttributeTag.vue?vue&type=template&id=cf8343d2&lang=pug"
import script from "./ShippoAttributeTag.vue?vue&type=script&lang=js"
export * from "./ShippoAttributeTag.vue?vue&type=script&lang=js"
import style0 from "./ShippoAttributeTag.vue?vue&type=style&index=0&id=cf8343d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports